export { default, createFilterOptions } from './Autocomplete';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/Autocomplete/index.js
// module id = 882
// module chunks = 2